import { withTranslation } from 'react-i18next';

import OrderSummary from './UpgradeOrderSummary';

export default withTranslation()(OrderSummary);
